import { render } from "./RouterLinkBreadCrumbs.vue?vue&type=template&id=6b4d672a&scoped=true"
import script from "./RouterLinkBreadCrumbs.vue?vue&type=script&lang=js"
export * from "./RouterLinkBreadCrumbs.vue?vue&type=script&lang=js"

import "./RouterLinkBreadCrumbs.vue?vue&type=style&index=0&id=6b4d672a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4d672a"]])

export default __exports__